import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import {numberWithComma, price} from "../../../../utils/formatters/Numbers";
import {RadioButton} from "primereact/radiobutton";
import {Dialog} from "primereact/dialog";
import {ListBox} from 'primereact/listbox';
import {dateDDMMYY} from '../../../../utils/formatters/Date';
import {calculateAmount, calculateReward} from "../../../../utils/calculate/Amount";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditPositionLoanableView = (props) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-8">
                        <TitlePage title="Prestamista \ Captura de Valores Prestables \ Editar Postura"/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Editar Restricción" className="p-button-secondary"
                                onClick={props.openRestrictionsDialog}
                                tabIndex={6}/> &nbsp;
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnCaptureValuesPage}
                                tabIndex={8}/>&nbsp;
                        <Button label="Guardar"
                                onClick={props.addPosition}
                                tabIndex={7}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Folio" isBold={true}/>
                        <SubtitleLabel header={props.positionData.folio}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cuenta" isBold={true}/>
                        <SubtitleLabel header={props.positionData.cuenta}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <SubtitleLabel header={props.positionData.emisora}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Disponible" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.positionData.disponible)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cantidad" isBold={true}/>
                        <NumberFormat name="cantidad"
                                      thousandSeparator={true}
                                      allowNegative={false}
                                      maxLength={17}
                                      required={true}
                                      decimalScale={0}
                                      fixedDecimalScale={false}
                                      placeholder="Ex: 99,99"
                                      customInput={InputText}
                                      onChange={props.onChangeText}
                                      value={props.positionData.cantidad}
                                      tabIndex={1}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Tasa Mín" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.positionData.tasaMin)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Plazo Max" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.positionData.plazoMax)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Tasa" isBold={true}/>
                        <NumberFormat name="tasa"
                                      decimalScale={2}
                                      id={8}
                                      required={true}
                                      allowNegative={false}
                                      thousandSeparator={true}
                                      customInput={InputText}
                                      value={props.positionData.tasa}
                                      onChange={props.onChangeText}
                                      placeholder="Ex: 99,99"
                                      tabIndex={2}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Plazo" isBold={true}/>
                        <NumberFormat name="plazo"
                                      thousandSeparator={true}
                                      maxLength={5}
                                      required={true}
                                      decimalScale={0}
                                      allowNegative={false}
                                      fixedDecimalScale={false}
                                      placeholder="Ex: 99,99"
                                      customInput={InputText}
                                      onChange={props.onChangeText}
                                      value={props.positionData.plazo}
                                      tabIndex={3}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Sobretasa" isBold={true}/>
                        <NumberFormat name="sobreTasa"
                                      decimalScale={2}
                                      id={8}
                                      required={true}
                                      thousandSeparator={true}
                                      allowNegative={false}
                                      customInput={InputText}
                                      value={props.positionData.sobreTasa}
                                      onChange={props.onChangeText}
                                      placeholder="Ex: 99,99"
                                      tabIndex={4}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Fecha Vence" isBold={true}/>
                        <Typography variant="subtitle2" gutterBottom
                                    style={props.positionData.validDate ? {} : {color: "red"}}>
                            {dateDDMMYY(props.positionData.fecVence)}
                        </Typography>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Precio" isBold={true}/>
                        <SubtitleLabel header={price(props.positionData.precio, "left")}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Premio Mín" isBold={true}/>
                        <NumberFormat name="premioMin"
                                      decimalScale={2}
                                      id={9}
                                      thousandSeparator={true}
                                      allowNegative={false}
                                      customInput={InputText}
                                      value={props.positionData.premioMin}
                                      onChange={props.onChangeText}
                                      placeholder="Ex: 99,99"
                                      tabIndex={5}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Total" isBold={true}/>
                        <SubtitleLabel header={calculateAmount(
                            props.positionData.precio,
                            props.positionData.cantidad)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Premio" isBold={true}/>
                        <SubtitleLabel header={calculateReward(
                            props.positionData.cantidad,
                            props.positionData.precio,
                            props.positionData.tasa,
                            props.positionData.plazo)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Fecha Valor" isBold={true}/>
                        <SubtitleLabel header={props.positionData.fechaValor}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Vigencia" isBold={true}/>
                        <RadioButton inputId="diaria" name="vigencia" value="D"
                                     checked={props.positionData.vigencia === 'D'}
                                     disabled={true}/>
                        <label htmlFor="diaria" className="p-radiobutton-label">Diaria</label>
                        &nbsp;&nbsp;
                        <RadioButton inputId="semanal" name="vigencia" value="S"
                                     checked={props.positionData.vigencia === 'S'}
                                     disabled={true}/>
                        <label htmlFor="semanal" className="p-radiobutton-label">Semanal</label>
                    </div>
                    <div className="p-col-12">
                        <Typography variant="subtitle2" className={"secondary-text"}>
                            <b>Valores Aceptados:</b>
                            {props.positionData.valuesAccepted}
                        </Typography>
                    </div>

                    <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                            onHide={props.onHideDialog} closable={false} style={{width: "35%"}}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-12 p-lg-12" align={"center"}>
                                <SubtitleLabel header="Valores aceptados" isBold={true}/>
                                <ListBox value={props.restrictionsPosture}
                                         filter={true}
                                         multiple={true}
                                         options={props.listRestrictions}
                                         onChange={props.onChangeRestrictions}
                                         optionLabel="nombre"
                                         style={{width: '15em'}} listStyle={{maxHeight: '250px'}}/>
                            </div>
                        </div>
                    </Dialog>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditPositionLoanableView);